<template>
  <div v-if="show">
    <div
      class="navigation-frame"
      :style="{
        left: frame.left + 'px',
        top: frame.top + 'px',
        width: frame.width + 'px',
        height: frame.height + 'px',
      }"
    ></div>
    <div
      class="navigation-message"
      :style="{
        left: left + 'px',
        top: top + 'px',
        borderTopRightRadius: width > frame.width && !is_moved ? '10px' : '0px',
        borderTopLeftRadius: is_moved ? '10px' : '0px',
      }"
    >
      <button
        @click="close()"
        style="position: absolute; right: 0; top: 0"
        class="btn btn-link btn-sm text-danger"
      >
        <i class="fa fa-times"></i>
      </button>
      <div class="message">
        {{ $t("message.navigation." + message) }}
      </div>
      <div class="button mt-3">
        <button
          @click="process_action"
          class="btn btn-outline-primary btn-sm btn-round"
        >
          {{ $t("message.navigation." + button_text) }}
        </button>
      </div>
      <div class="never-show-again">
        <button
          id="button-never-show-again"
          class="btn btn-sm btn-link text-muted px-0"
          @click="do_not_show_again"
        >
          {{ $t("message.navigation.never_show_again") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import routes from "./routes";
export default {
  data() {
    return {
      show: false,
      message: "",
      action: {},
      bind_element: "",
      button_text: "",

      left: 0,
      top: 0,
      width: 0,
      is_moved: false,
      frame: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      },
    };
  },
  methods: {
    close() {
      this.show = false;
    },
    do_not_show_again() {
      this.$store.commit("show_navigation", false);
      this.close();
    },
    process_action() {
      if (this.action.type == "target_click")
        document.querySelector(this.bind_element).click();
      if (this.action.type == "go_to_route") {
        this.$router.push({
          name: this.action.follow_route.name,
          params: this.action.follow_route.params,
        });
      }
      if (this.action.type == "create_document") {
        document.querySelector(this.bind_element).click();
        setTimeout(() => {
          this.$root.$emit("create_document", this.action.data);
        }, 1000);
      }
      this.close();
    },
    process_message(route_name) {
      if (this.$store.state.show_navigation !== false) {
        if (_.includes(_.keys(routes), route_name)) {
          setTimeout(() => {
            this.message = routes[route_name].message;
            this.action = routes[route_name].action;
            this.bind_element = routes[route_name].bind_element;
            this.button_text = routes[route_name].button_text;

            var curleft = 0;
            var curtop = 0;
            let obj = document.querySelector(this.bind_element);
            if (obj) {
              if (obj.offsetParent) {
                do {
                  curleft += obj.offsetLeft;
                  curtop += obj.offsetTop;
                } while ((obj = obj.offsetParent));

                this.left = curleft - 10;
                this.top = curtop + 8;
                this.frame.left = curleft - 10;
                this.frame.top = curtop - 10;
              }
              this.top += document.querySelector(
                this.bind_element,
              ).offsetHeight;
              this.frame.width =
                document.querySelector(this.bind_element).offsetWidth + 20;
              this.frame.height =
                document.querySelector(this.bind_element).offsetHeight + 20;
              this.show = true;
              setTimeout(() => {
                this.width = document.querySelector(
                  ".navigation-message",
                ).offsetWidth;

                if (this.left + this.width > window.innerWidth) {
                  this.left -= this.width - this.frame.width;
                  this.is_moved = true;
                } else {
                  this.is_moved = false;
                }
              }, 300);
            }
          }, 1000);
        } else {
          this.show = false;
        }
      } else {
        this.show = false;
      }
    },
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.process_message(this.$route.name);
      },
    },
  },
  mounted() {
    this.process_message(this.$route.name);

    this.$root.$on("trigger_navigation", (data) => {
      this.process_message(data);
    });
  },
};
</script>

<style scoped>
.navigation-message {
  position: absolute;
  z-index: 123123;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
  max-width: 300px;
  padding-top: 30px;
  /* border-top-left-radius: 0; */
  /* border-top-right-radius: 0; */
}
.navigation-frame {
  border: 2px solid #fff;
  position: absolute;
  z-index: 123121;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
}
</style>
